export const EXTERNAL_LINK_KIND = 'خارجی';
